import simpleSoilAttribute from './simpleSoilAttribute';

export const SURFACE_TEXTURE = simpleSoilAttribute({
  key: 'Soil Health: Surface Texture',
  ratingCol: {
    displayString: 'Soil texture',
    accessor: 'mapUnitRatingString',
  },
  ruleId: '2758',
  shortFormData: {
    AggregationMethod: 'Dominant Condition',
    HorizonAggregationMethod: 'Surface Layer',
    TiebreakRule: '-1',
  },
});
